export const labelMap = {
  price_range: {
    label: "price",
    plural: "prices",
  },
  medium: {
    label: "medium",
    plural: "mediums",
  },
  dimension_range: {
    label: "size",
    plural: "sizes",
  },
  period: {
    label: "time period",
    plural: "time periods",
  },
  gallery: {
    label: "gallery",
    plural: "galleries",
  },
  institution: {
    label: "institution",
    plural: "institutions",
  },
}
